export default __webpack_public_path__ + "static/media/newactiongroupbutton@2x.4a7d2343.png";